import { Page, PagesPermissions } from "../types/Authorization";
import { isPermissionGranted } from "./navPermissions";
import { PriceSheetKind } from "./priceList";

/**
 * The price sheets a price list can be read into (#30), and who may: edit +
 * finance on that page (prices are money). Matches the server's check.
 */
export const PRICE_SHEETS: Array<{ sheet: PriceSheetKind; label: string; edit: string; finance: string }> = [
    { sheet: "provider", label: "A provider's rate sheet", edit: PagesPermissions.PROVIDERS_EDIT, finance: PagesPermissions.PROVIDERS_FINANCE },
    { sheet: "request", label: "A mission request's quote", edit: PagesPermissions.MISSION_REQUESTS_EDIT, finance: PagesPermissions.MISSION_REQUESTS_FINANCE },
    { sheet: "mission", label: "A mission's services & pricing", edit: PagesPermissions.MISSIONS_EDIT, finance: PagesPermissions.MISSIONS_FINANCE },
];

export const priceSheetsFor = (pages: Page[]): PriceSheetKind[] =>
    PRICE_SHEETS.filter((entry) => isPermissionGranted(pages, entry.edit) && isPermissionGranted(pages, entry.finance)).map((entry) => entry.sheet);
